import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { api } from "../../api/api";
import OtpInput from "react-otp-input";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { Otp_url, Reotp_url } from "../../api/urls";
// import { X } from "lucide-react";
import { handleAuthModal } from "../../Redux/Auth";
import { useDispatch } from "react-redux";

const OTPNew = ({ setPage, onClose, token, countryCode, mobile }) => {
  const [otpSignUp, setOtpSignUp] = useState("");
  const [loadingg, setLoadingg] = useState(false);
  const [resendTimer, setResendTimer] = useState(30);
  const [isResending, setIsResending] = useState(false);

  const { handleSubmit } = useForm();
  const dispatch = useDispatch();
  const submitHandler = async () => {
    if (otpSignUp.length < 6) {
      setOtpSignUp("");
      toast.error("Please enter a valid 6-digit OTP");
      return;
    }

    setLoadingg(true);
    try {
      const response = await api.post(
        Otp_url,
        { recipient_otp: otpSignUp },
        {
          headers: {
            Token: token,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("OTP Verified!");
        document.body.style.overflow = "auto";

        dispatch(handleAuthModal(false));
        // setPage(2); // Go to next step
      } else {
        toast.error("Something went wrong while verifying OTP");
      }
    } catch (error) {
      toast.error("OTP verification failed");
    } finally {
      setLoadingg(false);
    }
  };
  // const handleResendOtp = async () => {
  //   try {
  //     setIsResending(true);

  //     // await api.post(Reotp_url, {}, { headers: { Token: token } });
  //  await api.post(Reotp_url, {
  //       mobile_number: `${countryCode}${mobile}`,
  //     });

  //     toast.success("OTP resent successfully");
  //     setOtpSignUp(""); // clear previous OTP
  //     setResendTimer(30); // reset timer
  //   } catch (error) {
  //      const msg =
  //   error.response?.data?.message ||   // case 1: {message: "..."}
  //   error.response?.data?.data ||      // case 2: {data: "..."} ← your case
  //   error.response?.data ||            // case 3: plain string
  //   "Something went wrong";            // fallback
  // toast.error(msg);
  //   } finally {
  //     setIsResending(false);
  //   }
  // };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setResendTimer((prev) => {
  //       if (prev === 0) {
  //         clearInterval(interval);
  //         return 0;
  //       }
  //       return prev - 1;
  //     });
  //   }, 1000);
  //   return () => clearInterval(interval);
  // }, []);

  const handleResendOtp = async () => {
    if (resendTimer !== 0) return;

    setResendTimer(30); // ✅ Trigger countdown restart

    try {
      setIsResending(true);

      await api.post(Reotp_url, {
        mobile_number: `${countryCode}${mobile}`,
      });

      toast.success("OTP resent successfully");
      setOtpSignUp("");
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.response?.data?.data ||
        error.response?.data ||
        "Something went wrong";

      toast.error(msg);
    } finally {
      setIsResending(false);
    }
  };

  useEffect(() => {
    if (resendTimer === 0) return;

    const interval = setInterval(() => {
      setResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [resendTimer]);

  return (
    // <motion.div
    //   initial={{ opacity: 0, y: 20 }}
    //   animate={{ opacity: 1, y: 0 }}
    //   transition={{ duration: 0.6 }}
    //   className="auth-card"
    // >
    //   <div className="xIcon" onClick={onClose}>
    //     <X />
    //   </div>
    <form onSubmit={handleSubmit(submitHandler)} style={styles.form}>
      <h2 style={styles.title}>Enter OTP</h2>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <OtpInput
          value={otpSignUp}
          onChange={setOtpSignUp}
          numInputs={6}
          inputType="tel"
          renderSeparator={<span></span>}
          renderInput={(props) => <input {...props} />}
          shouldAutoFocus
          containerStyle={{ justifyContent: "center" }}
          inputStyle={{
            width: "40px",
            height: "40px",
            margin: "0 5px",

            textAlign: "center",
            border: "1px solid #ccc",
            borderRadius: "4px",
          }}
        />
        {/* <OtpInput
  value={otpSignUp}
  onChange={(val) => {
    // Always pad or slice so it's exactly 6 characters
    if (val.length <= 6) {
      setOtpSignUp(val.padEnd(6, "")); 
    }
  }}
  numInputs={6}
  inputType="tel"
  shouldAutoFocus
  renderSeparator={<span></span>}
  renderInput={(props) => <input {...props} />}
  containerStyle={{ justifyContent: "center" }}
  inputStyle={{
    width: "40px",
    height: "40px",
    margin: "0 5px",
    textAlign: "center",
    border: "1px solid #ccc",
    borderRadius: "4px",
  }}
/> */}
      </div>

      <motion.button
        type="submit"
        disabled={loadingg}
        style={styles.button}
        whileHover={{ scale: 1.05 }}
      >
        {loadingg ? "Verifying..." : "Verify"}
      </motion.button>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <p style={{ fontSize: "12px", color: "grey" }}>
          Didn’t receive a code?{" "}
          <motion.span
            whileHover={{ scale: resendTimer === 0 ? 1.05 : 1 }}
            onClick={resendTimer === 0 ? handleResendOtp : null}
            style={{
              color: resendTimer === 0 ? "blue" : "grey",
              fontWeight: "700",
              fontSize: "12px",
              cursor: resendTimer === 0 ? "pointer" : "not-allowed",
            }}
          >
            {resendTimer > 0
              ? `Resend in ${resendTimer}s`
              : isResending
              ? "Resending..."
              : "Resend"}
          </motion.span>
        </p>
      </div>
    </form>
    // {/* </motion.div> */}
  );
};

const styles = {
  title: {
    textAlign: "center",
    marginBottom: "10px",
    color: "#333",
    fontSize: "24px",
    fontWeight: "bold",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
  },
  button: {
    background: "#000000",
    color: "#FFF",
    padding: "12px",
    fontSize: "16px",
    borderRadius: "5px",
  },
};

export default OTPNew;
